import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExpenseService } from 'src/app/services/expense.service';

@Component({
  selector: 'app-expenses-type-establishment-report',
  templateUrl: './expenses-type-establishment-report.component.html',
  styleUrls: ['./expenses-type-establishment-report.component.scss']
})
export class ExpensesTypeEstablishmentReportComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  category = null;
  loadingChart = true;
  results = [];

  constructor(
    private toastService: ToastrService,
    private expenseService: ExpenseService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.updateChart();
  }

  order(rows: any[]) {
    if (this.type == 0) {
      return rows;
    } else {
      rows.sort((a, b) => {
        if (this.type == 1) {
          return a.year - b.year;
        } else if (this.type == 2 || this.type == 3) {
          const dateA = new Date(a.month);
          const dateB = new Date(b.month);
          return dateA.getTime() - dateB.getTime();
        }
      });
      return rows;
    }
  }


  updateChart() {
    this.loadingChart = true;
    document.getElementById("expenses-type-establishment")['innerHTML'] = "";
    this.expenseService.getExpensesTypeEstablishment(
      DateUtil.parseDateToMilliseconds(this.start),
      DateUtil.parseDateToMilliseconds(this.end)
    ).subscribe({
      next: (response: ResponseObject) => {
        this.loadingChart = false;
        this.results = response.data;
        response.data = this.order(response.data);
        var kinds: { [key: number]: { name: string, data: number[] } } = {};
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          if (kinds[element.categoryId]) {
            kinds[element.categoryId].data[0] += element.total;
          } else {
            kinds[element.categoryId] = {name: "", data: [0]};
            kinds[element.categoryId].name = element.category;
            kinds[element.categoryId].data[0] = element.total;
          }
        }

        const kindsArray = Object.values(kinds);
        var names = [];
        for (const key in kinds) {
          if (kinds.hasOwnProperty(key)) {
            names.push(kinds[key].name);
          }
        }
        
        var options = {
          series: kindsArray,
          chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        
        xaxis: {
          categories: names,
          position: 'bottom',
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return MathUtil.formatCurrency(val);
            }
          }
        
        }
        };

        var chart = new ApexCharts(document.querySelector("#expenses-type-establishment"), options);
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingChart = false;
      }
    })
  }
}
